import { FileServiceError } from "./FileServiceError";

export class FileServiceUploadError extends FileServiceError {
  readonly error: Error;

  constructor(message: string, error: Error) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "FileServiceUploadError";
    this.error = error;
  }
}
